export const ClaimStatus = {
  UNCLAIMED: 'unclaimed',
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export interface TransactionStatus {
  status: 'pending' | 'confirmed' | 'failed' | 'unknown';
  block_number: number | null;
  confirmations: number;
  gas_used?: number;
}

export interface Claim {
  id: string;
  email: string | null;
  wallet_address: string;
  status: string;
  transaction_hash: string | null;
  basescan_url: string | null;
  transaction_status: TransactionStatus | null;
}

export interface CurrencyValue {
  amount: string;
  currency: string;
}

export interface GromaCoinOverview {
  name: string;
  symbol: string;
  current_price_per: CurrencyValue;
  market_capitalization: CurrencyValue;
  estimated_net_asset_value_per_share: CurrencyValue;
}

export interface ReitStatement {
  property_count: number;
  total_asset_value: CurrencyValue;
}

export interface EcosystemOverview {
  property_count: number;
  current_reit_statement?: ReitStatement;
}
